import { makeStyles } from "tss-react/mui";

const useDocumentDetailsStyles = makeStyles()((theme) => ({
  container: {
    minHeight: "36px",
    backgroundColor: theme.palette.surface.light,
    borderBottom: `1px solid ${theme.palette.strokes.defaultGrey}`,

    "&  button": {
      padding: "3px 16px",
      minHeight: "36px",
    },
    "&  button:nth-of-type(1)": {
      borderRight: `1px solid ${theme.palette.strokes.defaultGrey}`,
    },
  },
  search: {
    padding: "8px 16px",
    display: "flex",
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.strokes.defaultGrey}`,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.surface.light,
  },
  divider: {
    borderColor: theme.palette.strokes.defaultGrey,
  },
}));

export default useDocumentDetailsStyles;
